import React from 'react';
import useAppState from '../../AppStore';
import ToolDialogView from '../tooldialog/ToolDialogView';
import { useFlyins } from './Flyins';
import Drawer from '../drawer/Drawer';
import HorizontalResizable from '../resizable/HorizontalResizable';
import useDisplaySize from '../../useDisplaySize';

const Flyin = () => {
  const activeFlyin = useAppState((state) => state.activeFlyin);
  const setActiveFlyin = useAppState((state) => state.setActiveFlyin);
  const activeFlyinView = useAppState((state) => state.activeFlyinView);
  const setActiveFlyinView = useAppState((state) => state.setActiveFlyinView);
  const flyinWidth = useAppState((state) => state.flyinWidth);
  const setFlyinWidth = useAppState((state) => state.setFlyinWidth);

  const flyins = useFlyins();
  const { isSmallScreen } = useDisplaySize();

  if (!activeFlyin || !flyins[activeFlyin]) return null;

  const currentFlyin =
    flyins[activeFlyin].find((view) => view.key === activeFlyinView) ??
    flyins[activeFlyin].find((view) => view.isMainView);

  if (!currentFlyin) return null;

  const handleOnClose = (fn?: () => void) => {
    fn?.();
    setActiveFlyin(null);
  };

  const toolDialogView = (
    <ToolDialogView
      isMainView={currentFlyin.isMainView}
      toolName={currentFlyin.key}
      viewName="flyin"
      label={currentFlyin.label}
      viewComponent={currentFlyin.viewComponent}
      onClose={() => handleOnClose(currentFlyin.onClose)}
      goToMainView={() => setActiveFlyinView()}
    />
  );

  return isSmallScreen ? (
    <Drawer>{toolDialogView}</Drawer>
  ) : (
    <HorizontalResizable
      initialWidth={flyinWidth}
      minWidth={400}
      onResize={setFlyinWidth}
      side="left"
    >
      {toolDialogView}
    </HorizontalResizable>
  );
};

export default Flyin;
